import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import versionIcon from "../assets/icons/Version.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { RiFileList2Fill } from "react-icons/ri";
import { IoIosRocket } from "react-icons/io";
import { FaWrench } from "react-icons/fa";
import { IoBug } from "react-icons/io5";

const Version = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-19";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return `
${t("version1_26.release").replace(/<[^>]+>/g, "")}
${t("version1_26.date").replace(/<[^>]+>/g, "")}
${t("version1_26.environment").replace(/<[^>]+>/g, "")}

${t("version1_26.newFeatures").replace(/<[^>]+>/g, "")}
- ${t("version1_26.newFeature1").replace(/<[^>]+>/g, "")}
- ${t("version1_26.newFeature2").replace(/<[^>]+>/g, "")}
- ${t("version1_26.newFeature3").replace(/<[^>]+>/g, "")}
- ${t("version1_26.newFeature4").replace(/<[^>]+>/g, "")}
- ${t("version1_26.newFeature5").replace(/<[^>]+>/g, "")}

${t("version1_26.improve").replace(/<[^>]+>/g, "")}
- ${t("version1_26.improve1").replace(/<[^>]+>/g, "")}
- ${t("version1_26.improve2").replace(/<[^>]+>/g, "")}
- ${t("version1_26.improve3").replace(/<[^>]+>/g, "")}

${t("version1_26.bugfix").replace(/<[^>]+>/g, "")}
- ${t("version1_26.bugfix1").replace(/<[^>]+>/g, "")}
- ${t("version1_26.bugfix2").replace(/<[^>]+>/g, "")}
- ${t("version1_26.bugfix3").replace(/<[^>]+>/g, "")}
`.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3 mobile:flex-col mobile:items-stretch desktop:flex-row-reverse tabletpro:flex-row-reverse 
                tabletair:flex-row-reverse tabletmini:flex-row-reverse
                mini_mobile:flex-col mini_mobile:items-stretch">
                    {/* Copy button */}
                    <div className="mobile:flex mobile:justify-end mobile:order-1 mini_mobile:flex mini_mobile:justify-end">
                        <CopyButton text={buildCopyText(t)} />
                    </div>

                    {/* Icon + text */}
                    <div className="flex items-center gap-2 mobile:order-2">
                        <img
                            src={versionIcon}
                            alt="version"
                            className="w-9 h-12 mobile:w-9 mobile:h-9"
                        />
                        <p className="text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
                            {t("sidebar.version")}
                        </p>
                    </div>
                </div>


                <div className="mt-2 relative">
                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9] flex items-center gap-3">
                            <RiFileList2Fill /> {" "}
                            <Trans
                                i18nKey="version1_26.release"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="version1_26.date"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="version1_26.environment"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9] flex items-center gap-3">
                            <IoIosRocket /> {" "}
                            <Trans
                                i18nKey="version1_26.newFeatures"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-12 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.newFeature1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.newFeature2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.newFeature3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.newFeature4"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.newFeature5"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9] flex items-center gap-3">
                            <FaWrench /> {" "}
                            <Trans
                                i18nKey="version1_26.improve"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-12 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.improve1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.improve2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.improve3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <p className="text-[18px] font-normal text-[#0F172A] dark:text-[#F1F5F9] flex items-center gap-3">
                            <IoBug /> {" "}
                            <Trans
                                i18nKey="version1_26.bugfix"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-12 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.bugfix1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.bugfix2"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="version1_26.bugfix3"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.welcome")}
                            to="/"
                        />
                        <NextSectionCard
                            label={t("sidebar.install.title")}
                            to="/installation"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default Version